'use client';
import { useDevelopmentFlag } from '@mentimeter/development-tools/hooks';
import { useTranslations } from '@mentimeter/i18n';
import { Device } from '@mentimeter/ragnar-device';
import { getScreenshotUrl } from '@mentimeter/screenshots/getScreenshotUrl';
import dynamic from 'next/dynamic';
import { useAppState } from 'src/appState';
import CloneButton from 'src/components/CloneButton';
import { DecoratedImage } from 'src/ui/DecoratedImage';
import { Box } from '@mentimeter/ragnar-ui/box';
import { FrameBrowser } from '@mentimeter/ragnar-ui/frame-browser';

const TemplateHelpers = dynamic(
  () =>
    import('src/components/templates/TemplateHelpers').then(
      (m) => m.TemplateHelpers,
    ),
  {
    ssr: false,
  },
);

export const TemplateContent = ({
  template,
  title,
}: {
  template: any;
  title: string;
}) => {
  const { user } = useAppState();
  const showTemplateHelpers = useDevelopmentFlag('template-helpers') === 'on';
  const t = useTranslations('common');

  return (
    <>
      <Box mt="space8" width="100%">
        <Device.Match greaterThan={2}>
          <FrameBrowser ratio="landscape">
            <iframe
              title={'Mentimeter template: ' + template.title}
              src={`https://www.mentimeter.com/app/presentation/${template.presentationId}/template`}
              width="100%"
              height="100%"
              sandbox="allow-scripts allow-same-origin allow-forms"
            />
          </FrameBrowser>
        </Device.Match>

        <Device.Match lessThan={3}>
          <DecoratedImage
            src={
              template.previewImage?.fields.file.url
                ? template.previewImage?.fields.file.url
                : getScreenshotUrl({
                    presentationId: template.presentationId,
                    questionId: template.questionId,
                    hostname: 'www.mentimeter.com',
                  })
            }
            decoration="browser"
            enableDefaultSrcFit={false}
            alt={template.title || title}
          />
        </Device.Match>
      </Box>

      {(!!user?.features.template_editor || showTemplateHelpers) && (
        <TemplateHelpers
          userIsTemplateEditor={!!user?.features.template_editor}
          presentationId={template.presentationId}
        />
      )}

      <CloneButton mt="space8" name={title} seriesId={template.presentationId}>
        {t('templates.get_template')}
      </CloneButton>
    </>
  );
};
